import { z } from "zod"

export const createMissionGroupInputSchema = z.object({
    name: z.string().trim().min(1).optional(),
    missionIds: z.array(z.string()).default([]),
})

export const updateMissionGroupInputSchema = z.object({
    name: z.string().trim().min(1).optional(),
    missionIds: z.array(z.string()).optional(),
})

export type CreateMissionGroupInput = z.infer<typeof createMissionGroupInputSchema>
export type UpdateMissionGroupInput = z.infer<typeof updateMissionGroupInputSchema>

export const missionGroupRecordSchema = z.object({
    id: z.uuid(),
    name: z.string().nullable(),
    org_id: z.string(),
    mission_ids: z.array(z.string()).default([]),
})

export const missionGroupSchema = missionGroupRecordSchema.transform((r) => ({
    id: r.id,
    orgId: r.org_id,
    name: r.name ?? undefined,
    missionIds: r.mission_ids,
}))

export type MissionGroupRecord = z.infer<typeof missionGroupRecordSchema>
export type MissionGroup = z.infer<typeof missionGroupSchema>
export type CreatableMissionGroup = Omit<MissionGroup, "id">
